import yup from "src/validators/yup.Module";
import { PessoaDto } from "../../Entidade/Pessoa/Pessoa.Dto";
import { ProdutoNFCeDto } from "../NFCe/NFCe.Dto";

export interface NFeFiltrarDto {
  codigoStatusEnvio: string | null;
  dataEmissaoInicial: Date | null;
  dataEmissaoFinal: Date | null;
  serie: number | null;
}

export const NFeFiltrarSchema = yup.object().shape({
  nome: yup
    .string()
    .notRequired()
    .min(3, "O nome deve ter no mínimo 3 caracteres"),
});

export interface NFeDto {
  id: number;
  numeroNF: number;
  serie: number;
  emissaoDataHora: string;
  saidaEntradaDataHora: string | null;
  tipoOperacao: number;
  tributacaoId: number;
  finalidadeEmissao: number;
  referencia?: NFeCadastroReferenciaDto[];
  destinoOperacao: number;
  destinatario: PessoaDto;
  itens: ProdutoNFCeDto[];
  pagamento: NFeCadastroMeioPagamentoDto[];
  transporte: NFeCadastroTransporteDto;
  informacoesAdicionais: NFeCadastroInformacoesAdicionaisDto;
  consumidorFinal: number;
  total: TotalNFe;
  autorizacao: NFeAutorizacaoDto;
}

export interface NFeCadastroTransporteDto extends PessoaDto {
  modalidadeFrete?: number;
  placa: string;
  placaUF: string;
  volume: NFeCadastroVolumesDto[];
}

export interface NFeCadastroVolumesDto {
  quantidadeVolumes: number;
  especie: string;
  marca: string;
  pesoLiquido: number;
  pesoBruto: number;
}

export interface NFeCadastroInformacoesAdicionaisDto {
  informacoesAdicionaisFisco: string;
  informacoesComplementaresContribuinte: string;
}

export interface NFeCadastroMeioPagamentoDto {
  meioPagamento: number;
  valorPagamento: number;
  tipoIntegracao?: number | null;
  descricaoMeioPagamento?: string | null;
}

export interface TotalNFe {
  id: number;
  nFeId: number;
  valorBC: number;
  valorICMS: number;
  valorICMSDeson: number;
  valorFCPUFDest: number;
  valorICMSUFDest: number;
  valorICMSUFReme: number;
  valorFCP: number;
  valorBCST: number;
  valorST: number;
  valorFCPST: number;
  valorFCPSTRet: number;
  valorProduto: number;
  valorFrete: number;
  valorSeguro: number;
  valorDesconto: number;
  valorII: number;
  valorIPI: number;
  valorIPIDevol: number;
  valorPis: number;
  valorCofins: number;
  valorOutro: number;
  valorNotaFiscal: number;
  valorAproxTributos: number;
  valorTroco: number;
}

export interface NFeAutorizacaoDto {
  codigoStatusEnvio: number;
  descricaoStatusEnvio: string;
  codigoStatusResposta: number;
  descricaoMotivoResposta: string;
}

export interface NFeCadastroReferenciaDto {
  chaveAcesso: string;
}

export const STORAGENFE_KEY = "nfeTemp";

export function updateLocal<T extends object>(
  key: string,
  partial: Partial<T> | null
) {
  if (partial === null) {
    localStorage.removeItem(key);
    return;
  }

  const stored = localStorage.getItem(key);
  const current: T = stored ? JSON.parse(stored) : ({} as T);

  const updated: T = {
    ...current,
    ...partial,
  };

  localStorage.setItem(key, JSON.stringify(updated));
}

export function getLocal<T>(key: string): T | null {
  const stored = localStorage.getItem(key);
  return stored ? (JSON.parse(stored) as T) : null;
}
